import * as React from 'react';
import { Create, EditProps, SelectInput, SimpleForm, TextInput, useNotify, useTranslate } from 'react-admin';
import { getUserConfig } from '../providers/data.provider';
import { ERecipient } from '../enums';

const redirect = (basePath, id, data) => `/organizations/${getUserConfig()?.user?.organizationId}`;

export const NotificationsForm = (props: EditProps): React.ReactElement => {
	const notify = useNotify();
	const translator = useTranslate();

	return (
		<Create {...props} basePath="notifications" resource="notifications"
		        onSuccess={() => notify(translator('SENT_SUCCESSFULLY'))}>
			<SimpleForm redirect={redirect}>
				<h3>{translator('SEND_NOTIFICATIONS_TO_CLIENT')}</h3>
				<TextInput label="TITLE" source="title"/>
				<TextInput label="CONTENT" source="body"/>
				<SelectInput source="recipient" label="RECIPIENT" defaultValue={ERecipient.All} choices={[
					{ id: ERecipient.All, name: 'ALL' },
					{ id: ERecipient.Coach, name: 'COACH' },
					{ id: ERecipient.Trainee, name: 'TRAINEE' }
				]}/>
			</SimpleForm>
		</Create>);
};
